<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

const props = defineProps<{
  siteKey: string
}>()

const emit = defineEmits<{
  verify: [token: string]
  expire: []
  error: []
}>()

const container = ref<HTMLDivElement>()
let widgetId: string | undefined

function renderWidget() {
  if (!container.value || !window.turnstile)
    return
  widgetId = window.turnstile.render(container.value, {
    'sitekey': props.siteKey,
    'callback': (token: string) => emit('verify', token),
    'expired-callback': () => emit('expire'),
    'error-callback': () => emit('error'),
  })
}

onMounted(() => {
  if (document.querySelector('script[src*="turnstile"]')) {
    renderWidget()
    return
  }
  const script = document.createElement('script')
  script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
  script.async = true
  script.defer = true
  script.onload = renderWidget
  document.head.appendChild(script)
})

onUnmounted(() => {
  if (widgetId !== undefined)
    window.turnstile?.remove(widgetId)
})

defineExpose({
  reset: () => widgetId !== undefined && window.turnstile?.reset(widgetId),
})
</script>

<template>
  <div ref="container" />
</template>
